import React from "react";
import { observer } from "mobx-react";
import MindMePaymentsLogo from "../../../../../images/logos/mindme-payments-logo-center.png";
import {
  CustomLabel,
  FlexContainer,
  ModalComponent,
  SapphireBlueButton,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

type IProps = {
  onClickLogin: () => void;
  onClose: () => void;
};

const MerchantPortalPopupWrapper = styled.div`
  .merchant-portal-popup {
    .merchant-portal-content {
      border-radius: 10px !important;
      border: 1px solid #556bb8;
    }
    .merchant-portal-body {
      border-radius: 10px !important;
      border: 1px solid #556bb8;
    }
    .label-ch-29 {
      width: 29ch;
    }
    .merchant-portal-logo {
      height: 80px;
      width: auto;
    }
    .close-button {
      padding: 0px 13px !important;
    }
  }
`;
const MerchantPortalPopUp: React.FC<IProps> = ({ onClickLogin, onClose }) => {
  return (
    <MerchantPortalPopupWrapper>
      <ModalComponent
        titleFontSize="22px"
        onClose={() => onClose && onClose()}
        showFooter={false}
        showHeader={false}
        wrapperWidth="400px"
        bodyPadding="40px"
        bodyBackgroundColor="#EBF5FF"
        footerHeight="auto"
        minHeight="auto"
        modalClass="merchant-portal-popup"
        bodyClass="merchant-portal-body"
        contentClass="merchant-portal-content"
      >
        <FlexContainer fxLayout="column" spacing={20} alignItems="center">
          <img
            src={MindMePaymentsLogo}
            alt="MindMe Payments"
            className="merchant-portal-logo"
          />
          <CustomLabel
            color="#556BB8"
            fontSize={"14px"}
            textAlign="center"
            className="label-ch-29"
          >
            Login to the merchant portal to view additional funding, dispute and
            transaction information.
          </CustomLabel>
          <FlexContainer alignItems="center" justifyContent="center">
            <SapphireBlueButton
              minWidth="120px"
              height="40px"
              onClick={() => onClickLogin()}
              fontSize={"18px"}
            >
              Login
            </SapphireBlueButton>
          </FlexContainer>
        </FlexContainer>
      </ModalComponent>
    </MerchantPortalPopupWrapper>
  );
};

export default withRouter(observer(MerchantPortalPopUp));
